const mailTo = {
  beta: 'implementacao@combateafraude.com',
  prod: 'william.bonalume@combateafraude.com',
};

export default mailTo;
